// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html {
    scroll-behavior: smooth;
}

.plant-finder {
    min-height: 100vh;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: rgb(255, 252, 249)
}

.pf-container {
    align-items: center;
    justify-content: center;
    flex-direction: row;
    gap: 20px;
}

/*
    * Navbar
    */

.navbar {
    position: fixed;
    display: block;
    height: 54px;
    width: 100%;
    background-color: #fffcf9;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    z-index: 1000;
}

.navbar a {
    font-size: 15px;
    font-weight: 600;
    color: rgb(55, 84, 55);
    text-decoration-line: none;
}

.navbar a:hover {
    color: rgb(0, 128, 0)
}

.wrapper {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-left: auto;
    margin-right: auto;
}

.swiper {
    width: 100%;
    height: 380px;
    box-sizing: border-box;
}

.swiper-pagination-bullet-active {
    opacity: 1;
    background: #2a7e6d;
}

.swiper-slide {
    box-sizing: border-box;
    text-align: center;
    font-size: 18px;
    background: #F5F0E6;
    border: 1px solid #E0E0E0;
    width: 30vw;
    min-height: 330px;
    border-radius: 20px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    transition: transform 0.3s ease;

    /* Center slide text vertically */
    display: flex;
    justify-content: start;
    align-items: start;
}

irdmUd animation {
    transform: translateY(0px);
}

.mobileCta {
    background-color: rgb(255, 252, 249);
    animation: 500ms ease 0s 1;
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
    padding: 14px;
    border-top: 1px solid rgb(245, 241, 234);
    box-shadow: rgba(0, 0, 0, 0.05) 0px -4px 4px 0px;
}


@media screen and (min-width: 1200px) {
    .wrapper {
        width: 1200px;
    }
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;IACI,uBAAuB;AAC3B;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB;AACJ;;AAEA;IACI,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;AACb;;AAEA;;KAEK;;AAEL;IACI,eAAe;IACf,cAAc;IACd,YAAY;IACZ,WAAW;IACX,yBAAyB;IACzB,wCAAwC;IACxC,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,0BAA0B;AAC9B;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;IACf,mBAAmB;IACnB,yBAAyB;IACzB,WAAW;IACX,iBAAiB;IACjB,mBAAmB;IACnB,wCAAwC;IACxC,+BAA+B;;IAE/B,iCAAiC;IACjC,aAAa;IACb,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,oCAAoC;IACpC,0BAA0B;IAC1B,eAAe;IACf,SAAS;IACT,OAAO;IACP,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,aAAa;IACb,wCAAwC;IACxC,gDAAgD;AACpD;;;AAGA;IACI;QACI,aAAa;IACjB;AACJ","sourcesContent":["html {\n    scroll-behavior: smooth;\n}\n\n.plant-finder {\n    min-height: 100vh;\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    background-color: rgb(255, 252, 249)\n}\n\n.pf-container {\n    align-items: center;\n    justify-content: center;\n    flex-direction: row;\n    gap: 20px;\n}\n\n/*\n    * Navbar\n    */\n\n.navbar {\n    position: fixed;\n    display: block;\n    height: 54px;\n    width: 100%;\n    background-color: #fffcf9;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n    z-index: 1000;\n}\n\n.navbar a {\n    font-size: 15px;\n    font-weight: 600;\n    color: rgb(55, 84, 55);\n    text-decoration-line: none;\n}\n\n.navbar a:hover {\n    color: rgb(0, 128, 0)\n}\n\n.wrapper {\n    width: 100%;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-left: auto;\n    margin-right: auto;\n}\n\n.swiper {\n    width: 100%;\n    height: 380px;\n    box-sizing: border-box;\n}\n\n.swiper-pagination-bullet-active {\n    opacity: 1;\n    background: #2a7e6d;\n}\n\n.swiper-slide {\n    box-sizing: border-box;\n    text-align: center;\n    font-size: 18px;\n    background: #F5F0E6;\n    border: 1px solid #E0E0E0;\n    width: 30vw;\n    min-height: 330px;\n    border-radius: 20px;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n    transition: transform 0.3s ease;\n\n    /* Center slide text vertically */\n    display: flex;\n    justify-content: start;\n    align-items: start;\n}\n\nirdmUd animation {\n    transform: translateY(0px);\n}\n\n.mobileCta {\n    background-color: rgb(255, 252, 249);\n    animation: 500ms ease 0s 1;\n    position: fixed;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 1000;\n    padding: 14px;\n    border-top: 1px solid rgb(245, 241, 234);\n    box-shadow: rgba(0, 0, 0, 0.05) 0px -4px 4px 0px;\n}\n\n\n@media screen and (min-width: 1200px) {\n    .wrapper {\n        width: 1200px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
